// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2T2GV","additionalInfo":"AgreementModal_additionalInfo__1H13m"};